import { defineDefaultEnumValue } from 'src/lib/enum';

const COMMON_BRIEF_TYPE = {
  unifiedProduct: 'UnifiedProduct',
  unifiedContent: 'UnifiedContent',
  multiPromptTemplate: 'multiPromptTemplate',
};

const SPECIFIC_BRIEF_TYPE = {
  blogPostBuilder: 'BlogPostBuilder',
};

const CANVAS_BRIEF_TYPE = {
  canvas: 'CanvasBrief',
};

const DEPRECATED_BRIEF_TYPE = {
  blogPost: 'BlogPost',
  email: 'Email',
  unifiedPromotionalEmail: 'UnifiedPromotionalEmail',
  socialManual: 'SocialManual',
  shopifyProductBrief: 'ShopifyProduct',
};

/**
 * Brief type
 * @property {string} DEFAULT - default brief type
 */
export const BRIEF_TYPE = {
  ...COMMON_BRIEF_TYPE,
  ...SPECIFIC_BRIEF_TYPE,
  ...CANVAS_BRIEF_TYPE,
  ...DEPRECATED_BRIEF_TYPE,
} as const;
export type BriefType = (typeof BRIEF_TYPE)[keyof typeof BRIEF_TYPE];
defineDefaultEnumValue(BRIEF_TYPE, BRIEF_TYPE.unifiedProduct);

export const DEFAULT_BRIEF_TYPE = BRIEF_TYPE.unifiedProduct;

export const TITLE_PLACEHOLDER = 'Mindful Me';
export const DESCRIPTION_PLACEHOLDER =
  'A mobile app that helps you relax and manage stress with guided meditations that fit into your schedule.';
